import * as angular from 'angular';
import { ClassOfDropdownTransferComponent } from './class-of-dropdown-transfer.component';

export const ClassOfDropdownTransferModule = angular
  .module('classOfDropdownTransferModule', [])
  .component('classOfDropdownTransfer', ClassOfDropdownTransferComponent).name;
